<template>
	<div class="log-cls">
		<div v-if="list.length > 0">
			<section v-for="(item, index) in list" :key="index" class="cell" :class="{'hide': index === list.length - 1}">
				<div v-if="list.length === 1 && item.updateLogList[0].logType == 1" class="icon-cls el-icon-circle-plus-outline"></div>
				<div v-if="list.length === 1 && item.updateLogList[0].logType == 2" class="icon-cls el-icon-edit-outline"></div>
				<div v-if="list.length === 1 && item.updateLogList[0].logType == 3" class="icon-cls el-icon-delete"></div>
				<div v-if="list.length !== 1" class="icon-cls el-icon-coin"></div>
				<div class="header">
					<div class="top">
						<div>{{item.userName}}</div>
						<div>
							<span v-for="(item, index) in item.updateLogList" :key="index">{{item.logType == 1 ? '添加' : item.logType == 2 ? '修改' : '删除'}} {{item.columnName}} 字段: {{item.oldData}} <i v-if="item.newdata && item.oldData">→</i> <i v-if="item.newdata">{{item.newdata}}</i></span>
						</div>
					</div>
					<div class="bottom">{{item.createTime}}</div>
				</div>
			</section>
			<el-pagination
				@current-change="handleCurrentChange"
				layout="total, prev, pager, next, jumper"
				:total="total"
				:page-size="listQuery.pageSize"
				:pager-count="5">
			</el-pagination>
		</div>
		<el-empty v-else description="暂无数据"></el-empty>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
	name: "CustomerOperationLog",
	props: ['customerId', 'sourceType'],
	computed: {
        ...mapGetters([
			'userInfo',
        ])
    },
	watch: {
		customerId: {
			handler(val){
				if(val) {
					this.getList();
				}
			},
			immediate:true
		}
	},
	data() {
		return {
			total: 0,
			list: [],
			listQuery: {
				brand: '',
				customerId: '',
				pageNumber: 1,
				pageSize: 5
			}
		}
	},
	methods: {
		getList() {
			this.listQuery.brand = this.userInfo.brandIdentify;
			this.listQuery.customerId = this.customerId;
			this.$api.apiCustomerOperationLog(this.listQuery).then(response => {
				if(response.errcode != 0) return;
				this.list = response.data;
				this.total = parseInt(response.total);
			});
		},
		handleCurrentChange(val) {
			this.listQuery.pageNumber = val;
			this.getList();
		}
	}
}
</script>

<style lang="scss" scoped>
.log-cls {
	width: 100%;
	height: 100%;
	padding-left: 15px;
	box-sizing: border-box;

	& > div {
		text-align: center;
	}

	& .cell {
		width: 100%;
		min-height: 48px;
		background: #F6F7F9;
		position: relative;
		margin-bottom: 28px;
		text-align: left;

		& > .icon-cls {
			width: 30px;
			height: 30px;
			border: solid 1px #6C7E91;
			border-radius: 50%;
			position: absolute;
			top: 9px;
			left: -15px;
			font-size: 15px;
			color: #337EFF;
			text-align: center;
			line-height: 28px;
			font-weight: bold;
			background: #fff;
		}

		& > .header {
			padding-left: 40px;
			padding-top: 7px;
			box-sizing: border-box;
			& > .top {
				width: 100%;
				margin-bottom: 5px;

				& > div:nth-of-type(1) {
					font-style: normal;
					color: #337EFF;
					margin-right: 20px;
					display: inline-block;
					vertical-align: top;
					font-size: 14px;
					
					font-weight: 500;
					line-height: 16px;
				}

				& > div:nth-of-type(2) {
					display: inline-block;

					& > span {
						display: block;
						margin-bottom: 4px;
						font-size: 14px;
						
						font-weight: 500;
						color: #3C4353;
						line-height: 16px;
						
						& > i {
							font-style: normal;
							font-size: 14px;
							
							font-weight: 500;
							color: #3C4353;
							line-height: 16px;
						}
					}
				}

				& > span:nth-of-type(3) > i {
					font-style: normal;
					color: #337EFF;
					margin: 0 10px;
					font-weight: bold;
				}
			}

			& > .bottom {
				width: 100%;
				height: 16px;
				font-size: 12px;
				
				font-weight: 500;
				color: #C7C7C7;
				line-height: 16px;
			}
		}

		&::before {
			content: "";
			width: 1px;
			height: 16px;
			background: #A6AAB8;
			position: absolute;
			bottom: -23px;
			left: 0;
		}

		&.hide::before {
			display: none;
		}
	}


}
</style>
